import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { NgxDropzonePreviewComponent } from 'ngx-dropzone';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
	selector: 'custom-media-preview',
	template: require('./custom-media-preview.component.html'),
	styles: [require('./custom-media-preview.component.scss')],
	providers: [
		{
			provide: NgxDropzonePreviewComponent,
			useExisting: CustomMediaPreviewComponent
		}
	]
})
export class CustomMediaPreviewComponent extends NgxDropzonePreviewComponent
	implements OnInit, OnChanges {
	@Input() file: File;

	base64File: string;

	constructor(sanitizer: DomSanitizer) {
		super(sanitizer);
	}

	ngOnInit(): void {
		if (!this.file) {
			return;
		}
		this.readInputFile();
	}

	ngOnChanges(changes): void {
		if (changes.file.currentValue) {
			this.readInputFile();
		}
	}

	readInputFile(): void {
		this.readFile()
			.then((data: string): void => {
				this.base64File = data;
			})
			.catch();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/common/media-drop-zone/custom-media-preview/custom-media-preview.component.ts